import { Helmet } from 'react-helmet-async';

function ContactPageHelmetComponent() {
  return (
    <Helmet>
      {/* Sivun otsikko */}
      <title>Spiderlegs Productions | Varaa äänentoisto helposti | Tee varaus</title>

      {/* Meta-kuvaus */}
      <meta 
        name="description" 
        content="Tee varaus helposti Spiderlegs Productionsin lomakkeella. Järjestelmä tunnistaa vuokrauskoriin lisätyt tuotteet ja antaa automaattisesti oikean lomakkeen varauksen viimeistelyyn." 
      />

      {/* Meta-avainsanat */}
      <meta 
        name="keywords" 
        content="varaus, äänentoisto, vuokraus, tapahtumatekniikka, juhlat, häät, yritystilaisuus, tapahtumat, vuokrattavat laitteet, tapahtumien laitteet" 
      />

      {/* Meta-kirjoittaja */}
      <meta name="author" content="Arttu Stenius" />

      {/* Kanoninen linkki */}
      <link rel="canonical" href="https://spiderlegsproductions.com/tee-varaus" />

      {/* Open Graph -tunnisteet */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Varaa äänentoisto helposti | Tee varaus | Spiderlegs Productions" />
      <meta 
        property="og:description" 
        content="Tee varaus helposti Spiderlegs Productionsin lomakkeella. Järjestelmä tunnistaa vuokrauskoriin lisätyt tuotteet ja antaa automaattisesti oikean lomakkeen varauksen viimeistelyyn." 
      />
      <meta property="og:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
      <meta property="og:url" content="https://spiderlegsproductions.com/tee-varaus" />

      {/* Twitter Card -tunnisteet */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Varaa äänentoisto helposti | Tee varaus | Spiderlegs Productions" />
      <meta 
        name="twitter:description" 
        content="Tee varaus helposti Spiderlegs Productionsin lomakkeella. Järjestelmä tunnistaa vuokrauskoriin lisätyt tuotteet ja antaa automaattisesti oikean lomakkeen varauksen viimeistelyyn." 
      />
      <meta name="twitter:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
    </Helmet>
  );
}

export default ContactPageHelmetComponent;
